import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import { LoadingContainer } from "go-core/components/Loading";
import RouteHistory from "go-core/utils/routeHistory";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import FormatResourceStatus from "../../../../../../../../../../components/Common/Formatters/FormatResourceStatus/FormatResourceStatus";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";
import { fetchEmployeeConfig, onFetchEmployee } from "../../../utils";
import EmployeeForm from "../../components/EmployeeForm/EmployeeForm";

interface MatchParams {
	employeeId: string;
}

const OrganizationEmployeesIndexEditPage = (): JSX.Element => {
	const [employee, setEmployee] = useState<EmployeeApi | undefined>();
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>();
	const { addFlash } = useFlash();
	const { t } = useTranslation();
	const history = useHistory();
	const organization = useSelector(selectOrganization);
	const { employeeId } = useParams<MatchParams>();

	useEffect(() => {
		onFetchEmployee(employeeId, setEmployee, addFlash, t);
		fetchEmployeeConfig(setCustomFieldsConfig, addFlash);
	}, [addFlash, t, employeeId]);

	if (!employee || !customFieldsConfig) {
		return <LoadingContainer />;
	}

	const renderTitle = () => (
		<>
			{t("modules.employee.header.title")} "{employee.name}"
			<FormatResourceStatus status={employee.status} />
		</>
	);

	const goBack = () => RouteHistory.goBack(history, `/${organization.id}/employees/${employee.id}`);

	return (
		<>
			<Header title={renderTitle()} back={goBack} />
			<EmployeeForm employee={employee} customFieldsConfig={customFieldsConfig} />
		</>
	);
};
export default OrganizationEmployeesIndexEditPage;
